module.exports = __webpack_public_path__ + "img/load-4-2.41df93d0.png";